<h2 mat-dialog-title>Status Flowchart</h2>
<mat-dialog-content>
    <mat-card>
        <mat-card-content>
            <div class="chart-container">
                <div id="mermaidChart"></div>
            </div>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>